import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-02204470"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "app-container"
};
const _hoisted_2 = {
  class: "search-container"
};
const _hoisted_3 = {
  class: "search-left"
};
const _hoisted_4 = {
  class: "table-container-wrapper"
};
const _hoisted_5 = {
  class: "table-top-flex"
};
const _hoisted_6 = {
  class: "table-title"
};
const _hoisted_7 = {
  key: 0,
  class: "button-container"
};
const _hoisted_8 = {
  class: "dialog-footer"
};
import { listWell, deleteWell, addWell, updateWell, batchDeleteWell, listWellActuator } from "@/api/system1/tenant";
import { ref, unref, reactive, toRefs, watch, onMounted, nextTick, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { ElMessageBox, ElMessage } from 'element-plus';
import { weChatrequest } from '@/utils/request';
import searchMap from '@/views/deviceManage/deviceList/searchMap';
export default {
  __name: 'index',
  setup(__props) {
    const form = ref(null);
    const form1 = ref(null);
    const store = useStore();
    const router = useRouter();

    // 获取路由名称作为表格标题
    const tableTitle = computed(() => {
      const route = router.currentRoute.value;
      return route.meta?.title || route.name || '阀井管理';
    });
    // 获取用户类型
    const userType = store.state.common.userInfo.userType;
    // 获取当前租户下拉
    const tenantInfos = store.state.common.userInfo.tenantInfos;
    //所属地区配置
    const cityProps = ref({
      label: "name",
      value: "id",
      multiple: false,
      checkStrictly: false
    });
    const formatCode = function (code, column) {
      if (code == 1) {
        return '使用中';
      } else if (code == 2) {
        return '已拆除';
      } else {
        return '-';
      }
    };
    // 状态数据字典
    const statusOptions = ref([{
      dictValue: 1,
      dictLabel: "正常"
    }, {
      dictValue: 2,
      dictLabel: "维修中"
    }, {
      dictValue: 3,
      dictLabel: "停用"
    }]);
    const statusOptions1 = ref([]);
    const statusOptions2 = ref([]);
    const statusOptions3 = ref([{
      dictValue: 1,
      dictLabel: "是"
    }, {
      dictValue: 0,
      dictLabel: "否"
    }]);
    const state = reactive({
      // 遮罩层
      loading: true,
      loading1: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 阀井表格数据
      roleList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 是否显示弹出层（数据权限）
      openDataScope: false,
      // 日期范围
      dateRange: [],
      point: null,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        valveCode: '',
        valveName: '',
        areaId: null,
        status: null,
        tenantId: null
      },
      form1: {
        password: '',
        id: ''
      },
      // 表单参数
      form: {
        "tenantId": null,
        "valveCode": "",
        "valveName": "",
        "areaId": "",
        "location": "",
        "longitude": "",
        "latitude": "",
        "status": null
      },
      rules1: {
        password: [{
          required: true,
          message: "新密码不能为空",
          trigger: "blur"
        }, {
          pattern: /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+])[A-Za-z0-9!@#$%^&*()_+]{8,}$/,
          message: "密码必须包含字母、数字和英文特殊字符，长度为最少8位",
          trigger: "blur"
        }]
      },
      // 表单校验
      rules: {
        valveCode: [{
          required: true,
          message: "阀井编码不能为空",
          trigger: "blur"
        }, {
          max: 20,
          message: "阀井编码最多20个字符",
          trigger: "blur"
        }],
        areaId: [{
          required: true,
          message: "安装位置不能为空",
          trigger: "blur"
        }],
        valveName: [{
          required: true,
          message: "阀井名称不能为空",
          trigger: "blur"
        }, {
          max: 30,
          message: "阀井名称最多30个字符",
          trigger: "blur"
        }],
        status: [{
          required: true,
          message: "阀井状态不能为空",
          trigger: "change"
        }],
        tenantId: [{
          required: true,
          message: "所属租户不能为空",
          trigger: "change"
        }],
        location: [{
          required: true,
          message: "详细地址不能为空",
          trigger: "blur"
        }, {
          max: 50,
          message: "详细地址最多50个字符",
          trigger: "blur"
        }],
        longitude: [{
          required: true,
          message: "经度不能为空",
          trigger: "blur"
        }, {
          validator: (rule, value, callback) => {
            if (!value) {
              callback();
              return;
            }
            const numValue = parseFloat(value);
            // 检查是否为有效数字
            if (isNaN(numValue)) {
              callback(new Error("请输入有效的经度数值"));
              return;
            }
            // 检查范围：-180 到 180
            if (numValue < -180 || numValue > 180) {
              callback(new Error("经度范围应在-180到180之间"));
              return;
            }
            // 检查小数位最多20位
            const strValue = value.toString();
            const decimalIndex = strValue.indexOf('.');
            if (decimalIndex !== -1) {
              const decimalPart = strValue.substring(decimalIndex + 1);
              if (decimalPart.length > 20) {
                callback(new Error("经度小数位最多20位"));
                return;
              }
            }
            callback();
          },
          trigger: "blur"
        }],
        latitude: [{
          required: true,
          message: "不能为空",
          trigger: "blur"
        }, {
          validator: (rule, value, callback) => {
            if (!value) {
              callback();
              return;
            }
            const numValue = parseFloat(value);
            // 检查是否为有效数字
            if (isNaN(numValue)) {
              callback(new Error("请输入有效的纬度数值"));
              return;
            }
            // 检查范围：-90 到 90
            if (numValue < -90 || numValue > 90) {
              callback(new Error("纬度范围应在-90到90之间"));
              return;
            }
            // 检查小数位最多20位
            const strValue = value.toString();
            const decimalIndex = strValue.indexOf('.');
            if (decimalIndex !== -1) {
              const decimalPart = strValue.substring(decimalIndex + 1);
              if (decimalPart.length > 20) {
                callback(new Error("纬度小数位最多20位"));
                return;
              }
            }
            callback();
          },
          trigger: "blur"
        }]
        // email: [
        //   {
        //     pattern: /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/,
        //     message: "请输入正确的邮箱地址",
        //     trigger: "blur",
        //   },
        // ],
        // mobile: [
        //   {
        //     pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
        //     message: "请输入正确的手机号码",
        //     trigger: "blur",
        //   },
        // ],
      },
      saveLoading: false,
      saveLoading1: false,
      curWellId: "",
      searchFormData: [{
        prop: "tenantId",
        label: "所属租户",
        placeholder: "请选择所属租户",
        type: "list",
        isSelect: false,
        filterable: true,
        options: tenantInfos,
        props: {
          label: "tenantName",
          value: "tenantId"
        },
        change: () => {},
        span: 4,
        hideHandle: () => userType != 3
      }, {
        prop: "valveCode",
        label: "阀井编码",
        placeholder: "阀井编码",
        type: "text",
        isSelect: false,
        span: 4
      }, {
        prop: "valveName",
        label: "阀井名称",
        placeholder: "阀井名称",
        type: "text",
        isSelect: false,
        span: 4
      }, {
        prop: "areaId",
        label: "所属地区",
        placeholder: "请选择所属地区",
        type: "cascaderCheck",
        multiple: false,
        isSelect: false,
        options: statusOptions2,
        width: '100%',
        props: {
          label: "name",
          value: "id",
          multiple: false,
          checkStrictly: true
        },
        change: val => {
          console.log(val[val.length - 1], 'val=');
          state.queryParams.areaId = val[val.length - 1];
        },
        span: 24
      }, {
        prop: "status",
        label: "状态",
        placeholder: "请选择状态",
        type: "list",
        isSelect: false,
        filterable: true,
        options: statusOptions,
        props: {
          label: "dictLabel",
          value: "dictValue"
        },
        change: () => {},
        span: 4
      }],
      formHandle: [{
        label: "搜索",
        type: "primary",
        icon: "el-icon-search",
        class: "btn-liquid",
        handle: () => handleQuery()
      }, {
        label: "重置",
        icon: "el-icon-refresh",
        class: "commonDarkBtn",
        handle: () => resetQuery()
      }],
      //列表顶部顶部操作按钮数据
      buttonsList: [{
        buttonName: "新增",
        buttonStyle: "primary",
        hasPermi: ['valve-well:add'],
        className: 'addBtn',
        buttonIcon: "CirclePlus",
        exp: item => handleAdd(item)
      }, {
        buttonName: "删除",
        buttonStyle: "danger",
        hasPermi: ['valve-well:batch-delete'],
        className: 'deleteBtn',
        buttonIcon: "Delete",
        exp: item => handleDelete(item),
        disabledHandle(row) {
          return state.multiple;
        }
      }],
      deviceList: [],
      tableHeader1: [{
        prop: "actNum",
        label: "执行器编号"
      },
      // {
      //   prop: "valueInstallTime",
      //   label: "阀门安装日期",
      // },
      // {
      //   prop: "actFwVersion",
      //   label: "固件版本",
      // },
      {
        prop: "status",
        label: "状态",
        formatData: formatCode,
        type: function (row) {
          if (row.status == 1) {
            return 'success';
          } else if (row.status == 2) {
            return 'error';
          } else {
            return 'info';
          }
        }
      }, {
        prop: "installTime",
        label: "安装时间"
      }, {
        prop: "removeTime",
        label: "拆除时间"
      }],
      queryParams1: {
        pageNum: 1,
        pageSize: 10
      },
      tableHeader: [{
        prop: "valveCode",
        label: "阀井编码"
      }, {
        prop: "valveName",
        label: "阀井名称"
      }, {
        prop: "areaId",
        label: "所属地区"
      },
      // {
      //   prop: "status",
      //   label: "阀井状态",
      //   statusList: [
      //     {
      //       value: 1,
      //       label: "正常",
      //     },
      //     {
      //       value: 2,
      //       label: "维修中",
      //     },
      //     {
      //       value: 3,
      //       label: "停用",
      //     },
      //   ],
      // },
      {
        prop: "longitude",
        label: "经度"
      }, {
        prop: "latitude",
        label: "纬度"
      }, {
        prop: "location",
        label: "安装位置"
      }, {
        prop: "operation",
        label: "操作",
        width: "170px",
        fixed: "right",
        operation: [{
          name: '修改',
          clickFun: row => handleUpdate(row),
          hasPermi: ['valve-well:edit']
        }, {
          name: '删除',
          clickFun: row => handleDelete(row),
          hasPermi: ['valve-well:delete']
        }, {
          name: '执行器',
          clickFun: row => handleView(row),
          hasPermi: ['valve-well:query']
        }]
      }],
      form1Data: [{
        prop: "password",
        label: "新密码",
        placeholder: "请输入新密码",
        type: "text",
        isSelect: false,
        span: 24
      }]
    });
    onMounted(() => {
      // 获取地区下拉
      weChatrequest({
        url: '/api/v1/sysArea/findTree',
        method: "get"
      }).then(res => {
        statusOptions2.value = [res.data];
      });
      if (userType != 3) {
        state.queryParams.tenantId = state.form.tenantId = window.localStorage.getItem("tenantId");
      }
    });
    const handleCityChange = function (val) {
      state.form.areaId = val[val.length - 1];
    };
    /** 查询阀井列表 */
    const getList = function () {
      state.loading = true;
      listWell(state.queryParams).then(response => {
        state.roleList = {
          rows: response.data.records,
          total: response.data.total
        };
        state.loading = false;
      }).catch(() => {
        state.loading = false;
      });
    };
    /** 查询执行器列表 */
    const getList1 = function () {
      state.loading1 = true;
      listWellActuator(state.curWellId).then(response => {
        state.deviceList = {
          rows: response.data
          // total:response.data.total,
        };
        state.loading1 = false;
      }).catch(() => {
        state.loading1 = false;
      });
    };
    // 取消按钮（数据权限）
    const cancelDataScope = function () {
      state.openDataScope = false;
      state.form = {
        "tenantId": null,
        "valveCode": "",
        "valveName": "",
        "areaId": "",
        "location": "",
        "longitude": "",
        "latitude": "",
        "status": null
      };
    };
    const cancel = function () {
      state.open = false;
    };

    // 表单重置
    const reset = function () {
      state.form = {
        "tenantId": null,
        "valveCode": "",
        "valveName": "",
        "areaId": "",
        "location": "",
        "longitude": "",
        "latitude": "",
        "status": null
      };
    };
    /** 搜索按钮操作 */
    const handleQuery = function () {
      state.queryParams.pageNum = 1;
      getList();
    };
    /** 重置按钮操作 */
    const resetQuery = function () {
      state.dateRange = [];
      state.queryParams = {
        pageNum: 1,
        pageSize: 10,
        valveCode: '',
        valveName: '',
        areaId: null,
        status: null,
        tenantId: null
      };
      handleQuery();
    };
    // 多选框选中数据
    const handleSelectionChange = function (selection) {
      state.ids = selection.map(item => item.id);
      state.single = selection.length != 1;
      state.multiple = !selection.length;
    };
    /** 新增按钮操作 */
    const handleAdd = function () {
      state.openDataScope = true;
      state.title = "添加阀井";
      state.code = "";
      reset();
    };
    /** 修改按钮操作 */
    const handleUpdate = function (row) {
      state.title = "修改阀井";
      state.form = {
        ...row
      };
      state.code = row.areaId;
      state.point = {
        lng: row.longitude,
        lat: row.latitude
      };
      state.openDataScope = true;
    };
    const submit = function () {
      const formRef = unref(form1);
      formRef.commonForm.validate(valid => {
        if (valid) {
          state.saveLoading1 = true;
          let params = {
            ...state.form1
          };
          // updatePass(params).then(response => {
          //   if (response.code == 0) {
          //     ElMessage.success("密码重置成功");
          //     state.open = false;
          //     getList();
          //   } else {
          //     ElMessage.error(response.msg);
          //   }
          //   state.saveLoading1 = false;
          // }).catch(() => {
          //   state.saveLoading1 = false;
          // });
        }
      });
    };
    const cicyCheck = function (val, point) {
      state.form.location = val;
      state.form.longitude = point.lng;
      state.form.latitude = point.lat;
    };
    /** 修改/新增阀井提交按钮*/
    const submitDataScope = function () {
      const formRef = unref(form);
      formRef.validate(valid => {
        if (valid) {
          state.saveLoading = true;
          let params = {
            ...state.form
          };
          console.log(params, 'params---');
          if (state.form.id) {
            updateWell(params).then(response => {
              if (response.code == 0) {
                ElMessage.success("修改成功");
                state.openDataScope = false;
                getList();
              } else {
                ElMessage.error(response.msg);
              }
              state.saveLoading = false;
            }).catch(() => {
              state.saveLoading = false;
            });
          } else {
            addWell(params).then(response => {
              if (response.code == 0) {
                ElMessage.success("新增成功");
                state.openDataScope = false;
                //新增后重置
                resetQuery();
              } else {
                ElMessage.error(response.msg);
              }
              state.saveLoading = false;
            }).catch(() => {
              state.saveLoading = false;
            });
          }
        }
      });
    };
    const handleView = function (row) {
      state.curWellId = row.id;
      state.open = true;
    };
    /** 删除按钮操作 */
    const handleDelete = function (row) {
      const roleIds = row.id || state.ids;
      ElMessageBox.close();
      ElMessageBox.confirm('是否确认删除数据项?', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        if (row.id) {
          return deleteWell(roleIds);
        } else {
          return batchDeleteWell(roleIds);
        }
      }).then(res => {
        getList();
        ElMessage.success("删除成功");
      }).catch(function () {});
    };
    return (_ctx, _cache) => {
      const _component_commonForm = _resolveComponent("commonForm");
      const _component_Iconfont = _resolveComponent("Iconfont");
      const _component_el_button = _resolveComponent("el-button");
      const _component_commonTable = _resolveComponent("commonTable");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_cascader = _resolveComponent("el-cascader");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_form = _resolveComponent("el-form");
      const _component_commonDrawer = _resolveComponent("commonDrawer");
      const _directive_hasPermi = _resolveDirective("hasPermi");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_commonForm, {
        form: state.queryParams,
        formData: state.searchFormData,
        formHandle: state.formHandle
      }, null, 8, ["form", "formData", "formHandle"])])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_Iconfont, {
        name: "zhihangqiguanli",
        class: "table-title-icon"
      }), _createElementVNode("p", null, _toDisplayString(_unref(tableTitle)), 1)]), state.buttonsList.length ? (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.buttonsList, (item, index) => {
        return _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          key: index,
          class: _normalizeClass([item.className, item.buttonIcon]),
          loading: item.loading,
          icon: item.buttonIcon,
          type: item.buttonStyle,
          disabled: item.disabledHandle?.(item.prop, form.value),
          onClick: $event => item.exp(item)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.buttonName), 1)]),
          _: 2
        }, 1032, ["class", "loading", "icon", "type", "disabled", "onClick"])), [[_directive_hasPermi, item.hasPermi ? item.hasPermi : []]]);
      }), 128))])) : _createCommentVNode("", true)]), _withDirectives(_createVNode(_component_commonTable, {
        class: "flex-table",
        tableData: state.roleList,
        tableHeader: state.tableHeader,
        queryParams: state.queryParams,
        multipleSelection: state.ids,
        "onUpdate:multipleSelection": _cache[0] || (_cache[0] = $event => state.ids = $event),
        onGetList: getList,
        hasSelect: true,
        columnSetting: false,
        onSelectionChange: handleSelectionChange
      }, null, 8, ["tableData", "tableHeader", "queryParams", "multipleSelection"]), [[_directive_loading, state.loading]])]), _createVNode(_component_commonDrawer, {
        modelValue: state.openDataScope,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => state.openDataScope = $event),
        size: "550px",
        title: state.title,
        "close-on-click-modal": false,
        onClose: cancelDataScope
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submitDataScope,
          loading: _ctx.saveLoading
        }, {
          default: _withCtx(() => [_createTextVNode("确 定")]),
          _: 1
        }, 8, ["loading"]), _createVNode(_component_el_button, {
          onClick: cancelDataScope
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, {
          model: state.form,
          "status-icon": "",
          "label-width": "120px",
          ref_key: "form",
          ref: form,
          rules: state.rules,
          class: "commonForm",
          "label-position": "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            gutter: 15
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "阀井编码",
                prop: "valveCode"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.valveCode,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => state.form.valveCode = $event),
                  placeholder: "请输入阀井编码最多20个字符",
                  maxlength: "20",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "阀井名称",
                prop: "valveName"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.valveName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => state.form.valveName = $event),
                  placeholder: "请输入阀井名称最多30个字符",
                  maxlength: "30",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "阀井状态",
                prop: "status"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: state.form.status,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => state.form.status = $event),
                  placeholder: "请选择状态"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_option, {
                    label: "正常",
                    value: 1
                  }), _createVNode(_component_el_option, {
                    label: "维修中",
                    value: 2
                  }), _createVNode(_component_el_option, {
                    label: "停用",
                    value: 3
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _unref(userType) == 3 ? (_openBlock(), _createBlock(_component_el_col, {
              key: 0,
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "所属租户",
                prop: "tenantId"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: state.form.tenantId,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => state.form.tenantId = $event),
                  placeholder: "请选择所属租户"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tenantInfos), (item, index) => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      label: item.tenantName,
                      value: item.tenantId,
                      key: index
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "安装位置",
                prop: "areaId"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_cascader, {
                  placeholder: "请选择所属地区",
                  options: statusOptions2.value,
                  props: cityProps.value,
                  modelValue: state.code,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => state.code = $event),
                  filterable: "",
                  "collapse-tags": "",
                  "collapse-tags-tooltip": "",
                  clearable: "",
                  onChange: handleCityChange,
                  style: {
                    "width": "100%"
                  }
                }, null, 8, ["options", "props", "modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "详细地址",
                prop: "location"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.location,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => state.form.location = $event),
                  placeholder: "请输入详细地址最多50个字符",
                  maxlength: "50",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "经度",
                prop: "longitude"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.longitude,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => state.form.longitude = $event),
                  placeholder: "请输入经度"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "纬度",
                prop: "latitude"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.latitude,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => state.form.latitude = $event),
                  placeholder: "请输入纬度"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])])), [[_directive_loading, state.loadgingDataScope]])]),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(_component_commonDrawer, {
        modelValue: state.open,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => state.open = $event),
        size: "700px",
        title: "执行器列表",
        "close-on-click-modal": false,
        onClose: cancel,
        class: "wellDrawer"
      }, {
        default: _withCtx(() => [_withDirectives(_createVNode(_component_commonTable, {
          class: "flex-table wellTable",
          tableData: state.deviceList,
          tableHeader: state.tableHeader1,
          queryParams: state.queryParams1,
          onGetList: getList1,
          hasSelect: false,
          columnSetting: false
        }, null, 8, ["tableData", "tableHeader", "queryParams"]), [[_directive_loading, state.loading1]])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};